module.exports = __webpack_public_path__ + "media/video.9b3a3f28.mp4";